import { render } from "./StatusButton.vue?vue&type=template&id=4fda46a4"
import script from "./StatusButton.vue?vue&type=script&lang=js"
export * from "./StatusButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__